export default (value1, value2) => value1 === value2
    || (Number.isNaN(value1) && Number.isNaN(value2))
